import http from '@axios'
import paramsConverter from './utils/paramsConverter'

const resource = '/api/v1/certificate-employee'

export default {
  list(params = {}) {
    const paramsString = paramsConverter(params)

    return http.get(`${resource}${paramsString}`)
  },
  add(certificate) {
    return http.post(`${resource}`, certificate)
  },
  get(uuid) {
    return http.get(`${resource}/${uuid}`)
  },
  update(certificate, uuid) {
    return http.post(`${resource}/${uuid}?_method=PATCH`, certificate)
  },
  destroy(uuid) {
    return http.delete(`${resource}/${uuid}`)
  },
}
